export type SupportedCurrency = 'USD' | 'RUB';

export interface FormatPriceOptions {
    locale?: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
}

export const DEFAULT_LOCALE_BY_CURRENCY: Record<SupportedCurrency, string> = {
    USD: 'en-US',
    RUB: 'ru-RU',
};

export function resolveCurrencyLocale(currency: SupportedCurrency, preferredLocale?: string): string {
    if (currency === 'RUB') {
        return DEFAULT_LOCALE_BY_CURRENCY.RUB;
    }

    if (preferredLocale) {
        return preferredLocale;
    }

    return DEFAULT_LOCALE_BY_CURRENCY[currency] ?? 'en-US';
}

export function formatPriceWithCurrency(
    value: number,
    currency: SupportedCurrency,
    options: FormatPriceOptions = {}
): string {
    const locale = options.locale ?? resolveCurrencyLocale(currency);
    const minimumFractionDigits = options.minimumFractionDigits ?? 0;
    const maximumFractionDigits = options.maximumFractionDigits ?? 2;
    const normalizedValue = Number.isFinite(value) ? value : Number(value) || 0;

    return new Intl.NumberFormat(
        locale,
        {
            style: 'currency',
            currency,
            minimumFractionDigits,
            maximumFractionDigits,
        }
    ).format(normalizedValue);
}

